import StatCard from "../../../components/StatCard";
import { StatSummary } from "../../../components/StatSummary";
import ChartCard from '../../../components/chart/chart-card';
import Grid from "@mui/material/Grid";
import { MemberAttendanceSummary } from '../../../service/model/attendance.model';
import LinesChart from '../../../components/chart/line-chart';
import theme from '../../../app/app-theme';
import { useAppSelector } from '../../../app/hooks';
import { selectAttendances } from '../attendance.slice';
import AttendanceHeatMap from './attendance-heat-map';
import { subDays } from 'date-fns';
import { AttendanceIcon } from "../../../shared/icons";

const MemberAttendanceSummaryView = ({ attendanceSummary }: { attendanceSummary: MemberAttendanceSummary }) => {

    const attendances = useAppSelector(selectAttendances);
    return (
        <div>
            {attendanceSummary &&
                <>
                    <StatSummary>
                        <StatCard title="Last 4 Weeks" value={attendanceSummary.last28DaysAttendanceCount.toString()} icon={AttendanceIcon} />
                        <StatCard title="Last Attended Date" value={attendanceSummary.lastAttendanceDate.toString()} icon={AttendanceIcon} />
                        <StatCard title="Monthly Average" value={attendanceSummary.averageMonthlyAttendance.toString()} icon={AttendanceIcon} />
                        <StatCard title="Total Attendance Count" value={attendanceSummary.totalAttendanceCount.toString()} icon={AttendanceIcon} />
                    </StatSummary>
                    <Grid container direction="row" justifyContent="flex-start">
                        <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard>
                                <LinesChart
                                    data={attendanceSummary.monthlyAttendanceTrend.map(item => { return { month: item.key, attendance: item.value } }) ?? []}
                                    label={`Attendance Trend - Last 12 Months`}
                                    xAxisKey="month"
                                    height={204}
                                    lines={[
                                        { dataKey: 'attendance', name: 'Attendance', stroke: theme.palette.primary.main },
                                    ]}
                                />
                            </ChartCard>
                        </Grid>
                        <Grid size={{ lg: 4, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard sx={{ height: '290px' }}>
                                <h3 style={{ textAlign: 'center', marginBottom: '12px' }}>
                                    Attendance - Last 28 Days
                                </h3>
                                <AttendanceHeatMap
                                    presentDates={attendances.map(attendance => attendance.checkIn.split("T")[0])}
                                    maxDate={new Date()}
                                    minDate={subDays(new Date(), 27)}
                                />
                                <h4 style={{ textAlign: 'center', }}>
                                    You have attended {attendanceSummary.last28DaysAttendanceCount} out of 28 days in the last 4 weeks.
                                    
                                </h4>
                            </ChartCard>
                        </Grid>
                    </Grid>
                </>
            }
        </div>
    )
}

export default MemberAttendanceSummaryView;